import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import theme from '../../../common/theme';
import { styles } from './Tap2PayDiagnosis.styles';
import Icon from '../../Icon/Icon';

interface Props {
  label: string;
  value?: string | number | boolean | null;
  isError?: boolean;
}

const Tap2PayDiagnosisRow: React.FC<Props> = ({
  label,
  value,
  isError = false,
}) => {
  const { translate } = useTranslation();

  const valueBlock = useMemo(() => {
    if (typeof value === 'boolean') {
      return (
        <View testID="diagnosis-icon-value">
          <Icon
            size={20}
            name={value ? 'check-circle' : 'times-circle'}
            color={value ? theme.palette.green : theme.palette.red}
          />
        </View>
      );
    }

    if (value === undefined || value === null || value === '') {
      return (
        <Text
          testID="diagnosis-text-value"
          style={[styles.contentValue, styles.contentValueError]}
        >
          {translate('tap2PayDiagnosis.missing')}
        </Text>
      );
    }

    return (
      <Text
        testID="diagnosis-text-value"
        style={[styles.contentValue, isError && styles.contentValueError]}
      >
        {value}
      </Text>
    );
  }, [value, isError, translate]);

  return (
    <View testID="diagnosis-row" style={styles.contentRow}>
      <Text testID="diagnosis-label" style={styles.contentTitle}>
        {label}
      </Text>
      {valueBlock}
    </View>
  );
};

export default Tap2PayDiagnosisRow;
